import { useContext } from "react"
import { NotificationHubContext } from "../context"

const useNotifications = () => useContext(NotificationHubContext)

export default useNotifications
